import * as React from "react";
import { SnapshotSearchDocument } from "@/modules/snapshots/snapshotCollections/components/outcomes/search/types";
import { motion } from "framer-motion";
import { useToggle } from "react-use";
import { ChevronDown, ChevronRight } from "lucide-react";
import clsx from "clsx";

interface Props {
  documents: SnapshotSearchDocument[];
}

export const SnapshotCollectionsOutcomesSearchDocuments: React.FC<Props> = ({ documents }) => {
  const [isOpen, toggleIsOpen] = useToggle(false);
  if (!documents.length) {
    return null;
  }

  return (
    <div className="mb-4 rounded border border-gray-200 bg-white p-4 shadow-sm">
      <p
        className={clsx("m-0 flex cursor-pointer items-center text-sm font-semibold", {
          "border-b border-gray-300 pb-2": isOpen,
        })}
        onClick={toggleIsOpen}
      >
        {!isOpen ? <ChevronRight size={14} className="mr-1" /> : <ChevronDown size={14} className="mr-1" />}
        Searching {documents.length} documents
      </p>
      <div className="divide-y divide-gray-200" />
      <motion.div animate={{ opacity: isOpen ? 1 : 0 }}>
        {isOpen && (
          <div className="max-h-[500px] overflow-y-scroll">
            <ul className="m-0 mt-2 p-0">
              {documents.map((doc, index) => (
                <li key={index} className="m-0 mb-2 p-0 text-sm">
                  {doc.content}
                </li>
              ))}
            </ul>
          </div>
        )}
      </motion.div>
    </div>
  );
};
